import { $Q } from 'graditify-utils';

let wait = false;
let scrollOld = 0;
let endScrollHandle;

const scroll = () => {
  const collectionNavMobile = $Q('#collection-nav-js');
  if (!collectionNavMobile) { return; }

  const collectionNav = collectionNavMobile.closest('.collection-navigation').getBoundingClientRect();
  console.log(collectionNav.bottom);

  if (window.scrollY > scrollOld) {
    collectionNavMobile.classList.remove('sticky-up');
  } else if (window.scrollY < scrollOld) {
    collectionNavMobile.classList.add('sticky-up');
  }

  if (collectionNav.bottom < 0) {
    collectionNavMobile.classList.add('sticky');
  } else {
    collectionNavMobile.classList.remove('sticky');
    collectionNavMobile.classList.remove('sticky-up');
  }
  scrollOld = window.scrollY;
};

const initCollectionNavSticky = () => {
    document.addEventListener('scroll', () => {
        if (wait) {
          return;
        }
        wait = true;
        clearTimeout(endScrollHandle);
        scroll();
        setTimeout(() => {
          wait = false;
        }, 500);
        endScrollHandle = setTimeout(() => {
          scroll();
        }, 500);
      })
}

export { initCollectionNavSticky };
